import { normalizeSelectValue } from '../../model/normalize-select-value';
import { OptionType } from '../../model/types';
import { useQueryRequest } from 'components/table/contexts/query-request';
import { WarrantyLogFilter, useWarrantyWaUsers } from 'entities/warranty';
import { useMemo } from 'react';
import { MultiValue } from 'react-select';
import { Select } from 'shared';

export const SelectWaAdmin = () => {
  const { updateState, state: currentState } = useQueryRequest();
  const filter: WarrantyLogFilter = currentState.filter || {};

  const onChange = (val: MultiValue<OptionType>) => {
    updateState({
      filter: {
        ...filter,
        adminIds: normalizeSelectValue(val, true)
      }
    });
  };

  const { data, isFetching } = useWarrantyWaUsers();

  const options: OptionType[] = useMemo(() => {
    return (
      data
        ?.filter((x) => x.id && x.name)
        .map((x) => ({
          value: x.id?.toString()!,
          label: x.name!
        })) ?? []
    );
  }, [data]);

  const selectedIds = filter.adminIds ?? [];

  const selectedOptions: OptionType[] = useMemo(
    () => options.filter((option) => selectedIds.includes(Number(option.value))),
    [filter.adminIds, data]
  );

  return (
    <Select
      isMulti={true}
      options={options}
      value={selectedOptions}
      onChange={onChange}
      placeholder={isFetching ? 'Please wait...' : 'Any WA Admin'}
      isClearable={true}
      isDisabled={isFetching}
      instanceId={`WaAdmin-select`}
      isSearchable={true}
      highlightSelected
      isSolid
    />
  );
};
